import { render, staticRenderFns } from "./MailConfiguration.vue?vue&type=template&id=2d6f9806&"
import script from "./MailConfiguration.vue?vue&type=script&lang=ts&"
export * from "./MailConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports